export const learnDataObj = {
  id: "learn",
  description:
    "We are NeuroTX,  a student team from Aachen, Germany aiming to cultivate a learning environment and  hands-on experience in the field of neurotechnology",
  waveImage: require("../../images/waves.png"),
  backgroundPhilipp: require("../../images/DSC08470-2 1.png"),
  redBgPoint: require("../../images/square.png"),
  videos: {
    [0]: {
      label: "Philipp's Story",
      url: "https://www.youtube.com/embed/1Z1Z1Z1Z1Z1",
    },
    [1]: {
      label: "Philipp's Story",
      url: "https://www.youtube.com/embed/1Z1Z1Z1Z1Z1",
    },
    [2]: {
      label: "Philipp's Story",
      url: "https://www.youtube.com/embed/1Z1Z1Z1Z1Z1",
    },
    [3]: {
      label: "Philipp's Story",
      url: "https://www.youtube.com/embed/1Z1Z1Z1Z1Z1",
    },
  },
};
